import type {
	MessageToolAnalysisData,
	MessageToolAnalysisDocument,
} from "@virtual-brain-lib/types";

import { ToolCard } from "../core";
import { ToolCardDocumentAnalysisList } from "./ToolCardDocumentAnalysisList";

export function ToolCardDocumentAnalysis({
	state,
	onDocumentClick,
	className,
}: {
	readonly state: MessageToolAnalysisData;
	readonly onDocumentClick?: (doc: MessageToolAnalysisDocument) => void;
	readonly className?: string;
}) {
	const { status, statusText, documents } = state;

	const getDefaultStatusText = () => {
		if (status === "processing") {
			return "Analyzing documents";
		}

		const count = documents.length;

		if (count === 0) {
			return "No documents analyzed";
		}

		return `Analyzed ${count} document${count > 1 ? "s" : ""}`;
	};

	const getCompactSummary = () => {
		if (status === "processing") {
			return "Analyzing documents";
		}

		const count = documents.length;

		if (count === 0) {
			return "No documents analyzed";
		}

		return `${count} document${count > 1 ? "s" : ""} analyzed`;
	};

	const displayedStatusText = statusText ?? getDefaultStatusText();

	return (
		<ToolCard
			className={className}
			icon="scanSearch"
			status={status}
			statusText={displayedStatusText}
			compactSummary={getCompactSummary()}
			title="Excel Analysis"
		>
			<ToolCardDocumentAnalysisList documents={documents} onDocumentClick={onDocumentClick} />
		</ToolCard>
	);
}
